import "./HomePage.scss";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArchiveIcon, MapIcon } from "../../assets/icons";
import config from "../../config";


function HomePage() {
  const navigate = useNavigate();
  const organization = JSON.parse(localStorage.getItem("organization"));

  return (
    <section className="home-page-container ">      
      {
       organization.id && organization.logoUrl && <img src={organization.logoUrl || config.logoFull} alt="logo Amministrazione" className="customer-logo" />
      }
      <p className="home-intro">Benvenuti in Archeo</p>
      <p className="home-description">
        Per proseguire selezionare una opzione.
      </p>
      <div className="button-block">
        <button onClick={() => navigate("/MapView")} className="home-button">
          <span className="home-text">WEBGIS SCAVI ARCHEOLOGICI</span>
          <MapIcon height="100px" width="100px" />
        </button>
        <button onClick={() => navigate("/Pubblicazioni")} className="home-button">
          <span className="home-text">ARCHIVIO REPERTI E DOCUMENTI</span>
          <ArchiveIcon height="100px" width="100px" />
        </button>
      </div>
    </section>
  );
}

export default HomePage;
